import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import { getIncentiveList } from './Services/PayrollService';

const PayrollDashboard = () => {
  const salaryChartRef = useRef(null);
  const deptChartRef = useRef(null);
  const headcountChartRef = useRef(null);

  const [salaryChartInstance, setSalaryChartInstance] = useState(null);
  const [deptChartInstance, setDeptChartInstance] = useState(null);
  const [selectedFY, setSelectedFY] = useState('2024-25');
  const [historyFY, setHistoryFY] = useState('2024-25');
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

      const [ArrearManagementList, setArrearManagementList] = useState([]);
    
      useEffect(() => {
        getIncentiveList();
      }, []);
    
      const GetArrearList = () => {
        let params = {
          "ArrearId": 0,
           "OrgId": userDetails?.OrgId,
      "GUID": "string",
      "EmpId": userDetails?.EmpId,
          "PageNumber": 0,
          "PageSize": 0,
          "Search": "string",
          "ArrearStatusId": "string",
          "ArrearTypeId": "string",
          "LoggedInEmpId": 0
        };
        try {
          let res = getIncentiveList(params);
          setArrearManagementList(res?.Data);
        } catch (error) {
          console.error("Error fetching arrear list:", error);
        }
    
      }

  // History Data
  const historyData = {
    '2024-25': [
      { month: 'January 2025', emp: 47, gross: 3048000, incent: 180000, variable: 120000, tds: 178000, pf: 134000, net: 2980000, date: '31 Jan 2025' },
      { month: 'December 2024', emp: 47, gross: 3220000, incent: 620000, variable: 380000, tds: 195000, pf: 135000, net: 3168000, date: '31 Dec 2024' },
      { month: 'November 2024', emp: 46, gross: 2980000, incent: 150000, variable: 80000, tds: 172000, pf: 130000, net: 2905000, date: '30 Nov 2024' },
      { month: 'October 2024', emp: 46, gross: 2950000, incent: 140000, variable: 75000, tds: 170000, pf: 129000, net: 2875000, date: '31 Oct 2024' },
      { month: 'September 2024', emp: 45, gross: 2900000, incent: 130000, variable: 70000, tds: 168000, pf: 127000, net: 2832000, date: '30 Sep 2024' },
      { month: 'August 2024', emp: 45, gross: 2870000, incent: 120000, variable: 65000, tds: 165000, pf: 126000, net: 2803000, date: '31 Aug 2024' },
      { month: 'July 2024', emp: 44, gross: 2820000, incent: 110000, variable: 60000, tds: 162000, pf: 124000, net: 2754000, date: '31 Jul 2024' },
      { month: 'June 2024', emp: 44, gross: 2790000, incent: 100000, variable: 55000, tds: 160000, pf: 122000, net: 2727000, date: '30 Jun 2024' },
      { month: 'May 2024', emp: 43, gross: 2750000, incent: 95000, variable: 50000, tds: 158000, pf: 120000, net: 2688000, date: '31 May 2024' },
      { month: 'April 2024', emp: 43, gross: 2700000, incent: 90000, variable: 45000, tds: 155000, pf: 118000, net: 2638000, date: '30 Apr 2024' },
    ],
    '2023-24': [
      { month: 'March 2024', emp: 42, gross: 2680000, incent: 480000, variable: 220000, tds: 152000, pf: 116000, net: 2618000, date: '31 Mar 2024' },
      { month: 'February 2024', emp: 42, gross: 2640000, incent: 88000, variable: 42000, tds: 150000, pf: 114000, net: 2578000, date: '29 Feb 2024' },
      { month: 'January 2024', emp: 42, gross: 2600000, incent: 85000, variable: 40000, tds: 148000, pf: 112000, net: 2540000, date: '31 Jan 2024' },
      { month: 'December 2023', emp: 41, gross: 2750000, incent: 560000, variable: 310000, tds: 158000, pf: 113000, net: 2690000, date: '31 Dec 2023' },
      { month: 'November 2023', emp: 41, gross: 2550000, incent: 80000, variable: 35000, tds: 144000, pf: 110000, net: 2492000, date: '30 Nov 2023' },
      { month: 'October 2023', emp: 40, gross: 2500000, incent: 75000, variable: 30000, tds: 140000, pf: 108000, net: 2442000, date: '31 Oct 2023' },
      { month: 'September 2023', emp: 40, gross: 2480000, incent: 72000, variable: 28000, tds: 138000, pf: 106000, net: 2422000, date: '30 Sep 2023' },
      { month: 'August 2023', emp: 39, gross: 2440000, incent: 68000, variable: 25000, tds: 135000, pf: 104000, net: 2382000, date: '31 Aug 2023' },
      { month: 'July 2023', emp: 38, gross: 2400000, incent: 65000, variable: 22000, tds: 132000, pf: 102000, net: 2342000, date: '31 Jul 2023' },
      { month: 'June 2023', emp: 38, gross: 2360000, incent: 62000, variable: 20000, tds: 130000, pf: 100000, net: 2302000, date: '30 Jun 2023' },
      { month: 'May 2023', emp: 37, gross: 2320000, incent: 58000, variable: 18000, tds: 128000, pf: 98000, net: 2262000, date: '31 May 2023' },
      { month: 'April 2023', emp: 37, gross: 2280000, incent: 55000, variable: 15000, tds: 125000, pf: 96000, net: 2222000, date: '30 Apr 2023' },
    ],
    '2022-23': [
      { month: 'March 2023', emp: 36, gross: 2250000, incent: 350000, variable: 180000, tds: 122000, pf: 94000, net: 2198000, date: '31 Mar 2023' },
      { month: 'February 2023', emp: 36, gross: 2200000, incent: 52000, variable: 12000, tds: 118000, pf: 92000, net: 2148000, date: '28 Feb 2023' },
      { month: 'January 2023', emp: 35, gross: 2160000, incent: 50000, variable: 10000, tds: 115000, pf: 90000, net: 2108000, date: '31 Jan 2023' },
      { month: 'December 2022', emp: 35, gross: 2280000, incent: 320000, variable: 160000, tds: 120000, pf: 91000, net: 2228000, date: '31 Dec 2022' },
    ],
  };

  // Chart Datasets
  const chartDatasets = {
    '2024-25': {
      salary: [2700, 2750, 2790, 2820, 2870, 2900, 2950, 2980, 3220, 3048, 3170],
      tds: [155, 158, 160, 162, 165, 168, 170, 172, 195, 178, 184],
      incentive: [90, 95, 100, 110, 120, 130, 140, 150, 620, 180, 200],
      variable: [45, 50, 55, 60, 65, 70, 75, 80, 380, 120, 130],
      pf: [118, 120, 122, 124, 126, 127, 129, 130, 135, 134, 136],
    },
    '2023-24': {
      salary: [2280, 2320, 2360, 2400, 2440, 2480, 2500, 2550, 2750, 2600, 2640, 2680],
      tds: [125, 128, 130, 132, 135, 138, 140, 144, 158, 148, 150, 152],
      incentive: [55, 58, 62, 65, 68, 72, 75, 80, 560, 85, 88, 480],
      variable: [15, 18, 20, 22, 25, 28, 30, 35, 310, 40, 42, 220],
      pf: [96, 98, 100, 102, 104, 106, 108, 110, 113, 112, 114, 116],
    },
    '2022-23': {
      salary: [1950, 1980, 2010, 2040, 2080, 2120, 2160, 2200, 2280, 2160, 2200, 2250],
      tds: [105, 108, 110, 112, 115, 118, 115, 118, 120, 115, 118, 122],
      incentive: [40, 42, 45, 48, 50, 52, 50, 52, 320, 50, 52, 350],
      variable: [8, 10, 12, 14, 15, 16, 10, 12, 160, 10, 12, 180],
      pf: [80, 82, 84, 86, 88, 90, 90, 92, 91, 90, 92, 94],
    },
  };

  const months2425 = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb'];

  // Render History Table
  const renderHistory = () => {
    const data = historyData[historyFY] || [];
    return data.map((r, index) => (
      <tr
        key={index}
        onClick={() => openLockedMonth(r.month)}
        style={{ cursor: 'pointer' }}
      >
        <td className="text-left fw-bold">{r.month}</td>
        <td>{r.emp}</td>
        <td>₹{(r.gross / 100000).toFixed(1)}L</td>
        <td>₹{(r.incent / 100000).toFixed(1)}L</td>
        <td>₹{(r.variable / 100000).toFixed(1)}L</td>
        <td>₹{(r.tds / 100000).toFixed(1)}L</td>
        <td>₹{(r.pf / 100000).toFixed(1)}L</td>
        <td className="fw-bold" style={{ color: 'var(--brand)' }}>
          ₹{(r.net / 100000).toFixed(1)}L
        </td>
        <td>{r.date}</td>
        <td style={{ textAlign: 'center' }}>
          <span className="badge badge-paid">
            <i className="fa-solid fa-lock"></i> Locked
          </span>
        </td>
        <td style={{ textAlign: 'center' }}>
          <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
            <button
              className="btn btn-light btn-sm"
              onClick={(e) => { e.stopPropagation(); openLockedMonth(r.month); }}
              title="View Register"
            >
              <i className="fa-solid fa-table"></i>
            </button>
            <button
              className="btn btn-light btn-sm"
              onClick={(e) => { e.stopPropagation(); unlockMonth(r.month); }}
              title="Unlock for correction"
            >
              <i className="fa-solid fa-unlock"></i>
            </button>
          </div>
        </td>
      </tr>
    ));
  };

  const openLockedMonth = (month) => {
    if (window.confirm(`Open locked payroll register for ${month}?\n\nThe register will be read-only.`)) {
      window.location.href = 'Salary-Register';
    }
  };

  const unlockMonth = (month) => {
    if (window.confirm(`Unlock ${month} for correction?\n\nThis will move it to "Active" payroll processing.`)) {
      alert(`${month} has been unlocked.`);
    }
  };

  // Salary Trend Chart
  const buildSalaryChart = (fy) => {
    if (salaryChartInstance) salaryChartInstance.destroy();

    const ctx = document.getElementById('salaryChart');
    if (!ctx) return;

    const d = chartDatasets[fy];
    const labels = fy === '2024-25' ? months2425 : ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];

    const newChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [
          { label: 'Salary (₹K)', data: d.salary, borderColor: '#EC4119', fill: true, backgroundColor: 'rgba(236,65,25,.07)', tension: 0.35, pointRadius: 3, borderWidth: 2 },
          { label: 'TDS (₹K)', data: d.tds, borderColor: '#ef4444', fill: false, tension: 0.35, pointRadius: 3, borderWidth: 1.5, borderDash: [4, 3] },
          { label: 'Incentives(₹K)', data: d.incentive, borderColor: '#10b981', fill: false, tension: 0.35, pointRadius: 3, borderWidth: 1.5 },
          { label: 'Variable (₹K)', data: d.variable, borderColor: '#f59e0b', fill: false, tension: 0.35, pointRadius: 3, borderWidth: 1.5 },
          { label: 'PF+ESIC (₹K)', data: d.pf, borderColor: '#8b5cf6', fill: false, tension: 0.35, pointRadius: 3, borderWidth: 1.5, borderDash: [2, 2] },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: { label: (ctx) => `${ctx.dataset.label}: ₹${ctx.raw}K` }
          }
        },
        scales: {
          x: { grid: { color: '#f0f2f5' }, ticks: { font: { size: 11 }, color: '#888' } },
          y: { grid: { color: '#f0f2f5' }, ticks: { font: { size: 11 }, color: '#888', callback: v => `₹${v}K` } },
        }
      }
    });

    setSalaryChartInstance(newChart);
  };

  // Dept-wise CTC Chart
  const buildDeptChart = () => {
    if (deptChartInstance) deptChartInstance.destroy();

    const ctx = document.getElementById('deptChart');
    if (!ctx) return;

    const deptData = {
      Engineering: 1420000, Product: 625000, Design: 372000,
      Operations: 508000, HR: 337000, Finance: 323000
    };
    const deptHeadcount = { Engineering: 14, Product: 6, Design: 4, Operations: 5, HR: 3, Finance: 3 };
    const deptColors = ['#EC4119', '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#06b6d4'];

    const depts = Object.keys(deptData);
    const vals = Object.values(deptData).map(v => Math.round(v / 1000));

    const newChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: depts,
        datasets: [{
          label: 'Total CTC Cost (₹K)',
          data: vals,
          backgroundColor: deptColors.map(c => c + 'cc'),
          borderColor: deptColors,
          borderWidth: 1.5,
          borderRadius: 4,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        indexAxis: 'y',
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const dept = ctx.label;
                const hc = deptHeadcount[dept] || 0;
                const avg = hc ? Math.round(deptData[dept] / hc) : 0;
                return [`₹${ctx.raw}K total`, `${hc} employees`, `Avg ₹${avg.toLocaleString('en-IN')}`];
              }
            }
          }
        },
        scales: {
          x: { grid: { color: '#f0f2f5' }, ticks: { font: { size: 10 }, color: '#888', callback: v => `₹${v}K` } },
          y: { grid: { display: false }, ticks: { font: { size: 11 }, color: '#444' } },
        }
      }
    });

    setDeptChartInstance(newChart);

    // Build Legend
    const legendHTML = depts.map((dept, i) => {
      const hc = deptHeadcount[dept] || 0;
      const avg = hc ? Math.round(deptData[dept] / hc) : 0;
      return `
        <div style="display:flex;align-items:center;gap:4px;white-space:nowrap">
          <span style="width:8px;height:8px;border-radius:2px;background:${deptColors[i]};display:inline-block;flex-shrink:0"></span>
          <span style="color:var(--text-mid)">${dept}</span>
          <span style="color:var(--text-muted)">(${hc} · avg ₹${Math.round(avg / 1000)}K)</span>
        </div>`;
    }).join('');

    document.getElementById('deptLegend').innerHTML = legendHTML;
  };

  // Headcount Chart (static)
  const buildHeadcountChart = () => {
    if (headcountChartRef.current) return;

    const ctx = document.getElementById('headcountChart');
    if (!ctx) return;

    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb'],
        datasets: [
          {
            label: 'Headcount',
            type: 'bar',
            data: [43, 43, 44, 44, 45, 45, 46, 46, 47, 47, 48],
            backgroundColor: 'rgba(236,65,25,.15)',
            borderColor: '#EC4119',
            borderWidth: 1.5,
            yAxisID: 'y1',
            borderRadius: 3
          },
          {
            label: 'Avg Salary',
            type: 'line',
            data: [62790, 63953, 63409, 64090, 63777, 64444, 64130, 64782, 68510, 64851, 66520],
            borderColor: '#3b82f6',
            tension: 0.4,
            pointRadius: 2,
            borderWidth: 2,
            yAxisID: 'y2',
            fill: false
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: { legend: { display: false } },
        scales: {
          x: { grid: { color: '#f0f2f5' }, ticks: { font: { size: 11 }, color: '#888' } },
          y1: { grid: { color: '#f0f2f5' }, ticks: { font: { size: 11 }, color: '#888' }, position: 'left' },
          y2: {
            ticks: { font: { size: 11 }, color: '#3b82f6', callback: v => `₹${Math.round(v / 1000)}K` },
            position: 'right',
            grid: { drawOnChartArea: false }
          },
        }
      }
    });
    headcountChartRef.current = true;
  };

  // Toggle Series
  const toggleSeries = (e, idx) => {
    const chip = e.currentTarget;
    chip.classList.toggle('active');

    if (salaryChartInstance) {
      salaryChartInstance.data.datasets[idx].hidden = !chip.classList.contains('active');
      salaryChartInstance.update();
    }
  };

  // Initialize Charts
  useEffect(() => {
    buildSalaryChart(selectedFY);
    buildDeptChart();
    buildHeadcountChart();

    return () => {
      if (salaryChartInstance) salaryChartInstance.destroy();
      if (deptChartInstance) deptChartInstance.destroy();
    };
  }, [selectedFY]);

  return (
    <>


      <div className="container-fluid">
        {/* Topbar */}
        <div className="form-head d-flex flex-wrap align-items-center page-head mb-0">
          <div className="me-auto">
            <h2 className="font-w600 mb-0">Payroll Dashboard</h2>
            </div>
          <div className="rightside-tabs">
            <div className="topbar-actions">
              <span style={{ fontSize: '11px', fontWeight: '700', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.5px' }}>
                Manage:
              </span>
              <a href="Loan-Management" className="btn-og btn-og-secondary btn-og-sm" style={{ textDecoration: 'none' }}>
                <i className="fa-solid fa-hand-holding-dollar text-brand"></i> Loans &amp; Advances
              </a>
              <a href="Arrear-Management" className="btn-og btn-og-secondary btn-og-sm" style={{ textDecoration: 'none' }}>
                <i className="fa-solid fa-rotate-left" style={{ color: '#f59e0b' }}></i> Arrears
              </a>
              <a href="Incentive-Management" className="btn-og btn-og-secondary btn-og-sm" style={{ textDecoration: 'none' }}>
                <i className="fa-solid fa-trophy" style={{ color: '#10b981' }}></i> Incentives
              </a>
              <a href="Reimbursement-Management" className="btn-og btn-og-secondary btn-og-sm" style={{ textDecoration: 'none' }}>
                <i className="fa-solid fa-receipt" style={{ color: '#3b82f6' }}></i> Reimbursements
              </a>
              <div style={{ width: '1px', height: '20px', background: 'var(--border)', margin: '0 4px' }}></div>
              <span style={{ fontSize: '12px', color: 'var(--text-muted)', background: '#f1f3f5', padding: '4px 12px', borderRadius: '100px', fontWeight: '500' }}>
                <i className="fa-regular fa-calendar me-1"></i> FY 2024–25
              </span>
            </div>

          </div>
        </div>

        <div className="page-content">
          {/* KPI Row */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: '12px', marginBottom: '20px' }}>
            <div className="kpi-card">
              <div className="kpi-icon"><i className="fa-solid fa-users"></i></div>
              <div>
                <div className="kpi-label">Active Employees</div>
                <div className="kpi-val">48</div>
                <div className="kpi-trend up"><i className="fa-solid fa-arrow-up"></i> +2 this month</div>
              </div>
            </div>
            <div className="kpi-card">
              <div className="kpi-icon"><i className="fa-solid fa-indian-rupee-sign"></i></div>
              <div>
                <div className="kpi-label">Monthly Payroll</div>
                <div className="kpi-val">₹31.7L</div>
                <div className="kpi-trend up"><i className="fa-solid fa-arrow-up"></i> +4.2% vs last</div>
              </div>
            </div>
            <div className="kpi-card">
              <div className="kpi-icon"><i className="fa-solid fa-money-bill-transfer"></i></div>
              <div>
                <div className="kpi-label">YTD Payout</div>
                <div className="kpi-val">₹3.1Cr</div>
                <div className="kpi-sub">Apr 2024 – Feb 2025</div>
              </div>
            </div>
            <div className="kpi-card">
              <div className="kpi-icon"><i className="fa-solid fa-file-invoice-dollar"></i></div>
              <div>
                <div className="kpi-label">TDS Deducted YTD</div>
                <div className="kpi-val">₹18.4L</div>
                <div className="kpi-sub">Deposited to Govt.</div>
              </div>
            </div>
            <div className="kpi-card">
              <div className="kpi-icon"><i className="fa-solid fa-shield-halved"></i></div>
              <div>
                <div className="kpi-label">PF + ESIC YTD</div>
                <div className="kpi-val">₹6.8L</div>
                <div className="kpi-sub">EE + ER combined</div>
              </div>
            </div>
          </div>

          {/* Payroll Processing Section */}
          <div className="sec-header">
            <h5><i className="fa-solid fa-play-circle text-brand me-1"></i> Payroll Processing</h5>
            <div className="sec-header-right">
              <span style={{ fontSize: '11.5px', color: 'var(--text-muted)' }}>Current &amp; unlocked months available to process</span>
            </div>
          </div>

          <div className="dash-grid" id="activeMonthCards">
            {/* March 2025 - Current */}
            <div className="month-card current">
              <div className="mc-top">
                <div>
                  <div className="mc-month">March 2025</div>
                  <div className="mc-year">Current Month</div>
                </div>
                <span className="mc-tag">Current</span>
              </div>
              <div className="mc-stats">
                <div className="mc-stat-item"><div className="mc-stat-label">Employees</div><div className="mc-stat-val">48</div></div>
                <div className="mc-stat-item"><div className="mc-stat-label">Status</div><div className="mc-stat-val"><span className="badge badge-pending">Not Started</span></div></div>
              </div>
              <div className="mc-actions">
                <button className="btn btn-brand btn-sm w-100" onClick={() => window.location.href = 'Run-Payroll'}>
                  <i className="fa-solid fa-play"></i> Run Payroll
                </button>
              </div>
            </div>

            {/* February 2025 - In Progress */}
            <div className="month-card current" style={{ borderColor: 'rgb(84 193 162)', background: 'rgb(244 255 248)' }}>
              <div className="mc-top">
                <div>
                  <div className="mc-month">February 2025</div>
                  <div className="mc-year">Awaiting disbursement</div>
                </div>
                <span className="mc-tag" style={{ background: 'rgb(220 252 231)', color: 'rgb(44 143 118)' }}>In Progress</span>
              </div>
              <div className="mc-stats">
                <div className="mc-stat-item"><div className="mc-stat-label">Employees</div><div className="mc-stat-val">48</div></div>
                <div className="mc-stat-item"><div className="mc-stat-label">Net Payable</div><div className="mc-stat-val">₹31.7L</div></div>
                <div className="mc-stat-item"><div className="mc-stat-label">Step</div><div className="mc-stat-val">7 / 9</div></div>
              </div>
              <div className="mc-actions">
                <button className="btn btn-brand btn-sm" style={{ flex: 1 }} onClick={() => window.location.href = 'Run-Payroll'}>
                  <i className="fa-solid fa-play"></i> Run Payroll
                </button>
                <button className="btn btn-light btn-sm" style={{ flex: 1 }} onClick={() => window.location.href = 'Salary-Register'}>
                  <i className="fa-solid fa-table"></i> View Payroll
                </button>
              </div>
            </div>

            {/* January 2025 - Unlocked */}
            <div className="month-card unlocked">
              <div className="mc-top">
                <div>
                  <div className="mc-month">January 2025</div>
                  <div className="mc-year">Unlocked for correction</div>
                </div>
                <span className="mc-tag">Unlocked</span>
              </div>
              <div className="mc-stats">
                <div className="mc-stat-item"><div className="mc-stat-label">Employees</div><div className="mc-stat-val">47</div></div>
                <div className="mc-stat-item"><div className="mc-stat-label">Net Paid</div><div className="mc-stat-val">₹30.8L</div></div>
                <div className="mc-stat-item"><div className="mc-stat-label">Unlocked by</div><div className="mc-stat-val">Admin</div></div>
              </div>
              <div className="mc-actions">
                <button className="btn btn-warning btn-sm" style={{ flex: 1, color: '#fff' }} onClick={() => window.location.href = 'Run-Payroll'}>
                  <i className="fa-solid fa-rotate"></i> Re-run Payroll
                </button>
                <button className="btn btn-light btn-sm" style={{ flex: 1 }} onClick={() => window.location.href = 'Salary-Register'}>
                  <i className="fa-solid fa-table"></i> View Payroll
                </button>
              </div>
            </div>
          </div>

          {/* Charts Row */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '20px' }}>
            {/* Salary Expense Trend */}
            <div className="chart-card">
              <div className="chart-card-header">
                <i className="fa-solid fa-chart-line text-brand"></i>
                <h6>Salary Expense Trend</h6>
                <select
                  className="form-select ms-auto"
                  style={{ width: '96px', fontSize: '11px', padding: '3px 7px' }}
                  value={selectedFY}
                  onChange={(e) => setSelectedFY(e.target.value)}
                >
                  <option value="2024-25">FY 2024–25</option>
                  <option value="2023-24">FY 2023–24</option>
                  <option value="2022-23">FY 2022–23</option>
                </select>
              </div>
              <div className="chart-card-body">
                <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', marginBottom: '10px' }} id="breakdownChips">
                  <span className="breakdown-chip chip-salary active" onClick={(e) => toggleSeries(e, 0)}>
                    <span style={{ width: '7px', height: '7px', background: '#EC4119', borderRadius: '2px', display: 'inline-block' }}></span> Salary
                  </span>
                  <span className="breakdown-chip chip-tds active" onClick={(e) => toggleSeries(e, 1)}>
                    <span style={{ width: '7px', height: '7px', background: '#ef4444', borderRadius: '2px', display: 'inline-block' }}></span> TDS
                  </span>
                  <span className="breakdown-chip chip-incentive active" onClick={(e) => toggleSeries(e, 2)}>
                    <span style={{ width: '7px', height: '7px', background: '#10b981', borderRadius: '2px', display: 'inline-block' }}></span> Incent.
                  </span>
                  <span className="breakdown-chip chip-pf active" onClick={(e) => toggleSeries(e, 4)}>
                    <span style={{ width: '7px', height: '7px', background: '#8b5cf6', borderRadius: '2px', display: 'inline-block' }}></span> PF+ESI
                  </span>
                </div>
                <canvas id="salaryChart" height="210"></canvas>
              </div>
            </div>

            {/* Dept-wise CTC */}
            <div className="chart-card">
              <div className="chart-card-header">
                <i className="fa-solid fa-building text-brand"></i>
                <h6>Dept-wise CTC Distribution</h6>
                <select className="form-select ms-auto" style={{ width: '96px', fontSize: '11px', padding: '3px 7px' }}>
                  <option>Feb 2025</option>
                  <option>Jan 2025</option>
                  <option>FY 2024–25</option>
                </select>
              </div>
              <div className="chart-card-body">
                <canvas id="deptChart" height="180"></canvas>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '10px', fontSize: '11px' }} id="deptLegend"></div>
              </div>
            </div>

            {/* Headcount & Avg Salary */}
            <div className="chart-card">
              <div className="chart-card-header">
                <i className="fa-solid fa-users text-brand"></i>
                <h6>Headcount &amp; Avg. Salary</h6>
                <select className="form-select ms-auto" style={{ width: '96px', fontSize: '11px', padding: '3px 7px' }}>
                  <option>FY 2024–25</option>
                  <option>FY 2023–24</option>
                </select>
              </div>
              <div className="chart-card-body">
                <canvas id="headcountChart" height="210"></canvas>
              </div>
            </div>
          </div>

          {/* Payroll History */}
          <div className="sec-header">
            <h5><i className="fa-solid fa-clock-rotate-left text-brand me-1"></i> Payroll History</h5>
            <div className="sec-header-right">
              <select
                className="form-select"
                style={{ width: '120px' }}
                value={historyFY}
                onChange={(e) => setHistoryFY(e.target.value)}
              >
                <option value="2024-25">FY 2024–25</option>
                <option value="2023-24">FY 2023–24</option>
                <option value="2022-23">FY 2022–23</option>
              </select>
            </div>
          </div>

          <div className="chart-card">
            <div className="chart-card-body" style={{ padding: 0 }}>
              <table className="history-tbl">
                <thead>
                  <tr>
                    <th className="text-left">Month</th>
                    <th>Employees</th>
                    <th>Gross Payable</th>
                    <th>Incentives</th>
                    <th>Variable</th>
                    <th>TDS</th>
                    <th>PF (EE+ER)</th>
                    <th>Net Paid</th>
                    <th>Disbursed On</th>
                    <th style={{ textAlign: 'center' }}>Status</th>
                    <th style={{ textAlign: 'center' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {renderHistory()}
                </tbody>
                <tfoot>
                  <tr>
                    <td className="text-left fw-bold">FY Total</td>
                    <td>—</td>
                    <td id="hf-gross">—</td>
                    <td id="hf-incent">—</td>
                    <td id="hf-var">—</td>
                    <td id="hf-tds">—</td>
                    <td id="hf-pf">—</td>
                    <td id="hf-net" className="fw-bold" style={{ color: 'var(--brand)' }}>—</td>
                    <td>—</td>
                    <td>—</td>
                    <td>—</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollDashboard;